import { render, staticRenderFns } from "./setMeal.vue?vue&type=template&id=5262ede6&scoped=true&"
import script from "./setMeal.vue?vue&type=script&lang=js&"
export * from "./setMeal.vue?vue&type=script&lang=js&"
import style0 from "./setMeal.vue?vue&type=style&index=0&id=5262ede6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5262ede6",
  null
  
)

export default component.exports